$(document).ready(function (e) {
    if ($('.charts').length) {
        let $charts = $('.chart'),
            decimal_separator = $('.dashboards').attr('data-decimal-separator'),
            thousands_separator = $('.dashboards').attr('data-thousands-separator'),
            lang = $('.dashboards').attr('data-lang');

        $('.grid-stack').gridstack();

        $('.grid-stack').on('gsresizestop', function (event, elem) {
            drawDashboardCharts();
        });

        $('.grid-stack').on('change', function (event, items) {
            updateChartLayoutParams();
        });

        function checkScroll($element) {
            var $scrollArrow = $element.parents('.chart').find('.scroll-arrow');
            var isAtBottom = $element.scrollTop() + $element.innerHeight() >= $element[0].scrollHeight;

            if (isAtBottom) {
                $scrollArrow.hide();
            } else {
                $scrollArrow.show();
            }
        }

        $(document).on('mouseenter', '.chart-table-responsive', function() {
            var $scrollArrow = $(this).parents('.chart').find('.scroll-arrow');
            var isAtBottom = $(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight;

            if (!isAtBottom) {
                $scrollArrow.show();
            }
        });

        $(document).on('mouseleave', '.chart-table-responsive', function() {
            var $scrollArrow = $(this).parents('.chart').find('.scroll-arrow');
            $scrollArrow.hide();
        });

        $(document).on('click', '.sort-chart-column', function (e) {
            e.preventDefault();
            let field = $(this).attr('data-column'),
                $order = $(this).find('.btn_active'),
                order = $order.hasClass('fa-sort-up') ? 'desc' : 'asc',
                $chart = $(this).parents('.chart'),
                payload = JSON.parse($($chart).attr('data-chart'));

            $.ajax({
                type: "GET",
                url: `/chart/${payload.id}`,
                data: {
                    sort: order,
                    field,
                    render: 'chart'
                },
                success: function (res) {
                    let $chart_container = $('#chart-' + payload.id)[0];

                    if (payload.chart_type === 'Bar') {

                        google.charts.load('current', {packages: ['corechart', 'bar'], 'language': lang});
                        google.charts.setOnLoadCallback(function () {
                            let data = google.visualization.arrayToDataTable(res.data);
                            let options = res.options;
                            let chart = new google.visualization.ColumnChart($chart_container);
                            let formatting = new google.visualization.NumberFormat({
                                decimalSymbol: decimal_separator,
                                groupingSymbol: thousands_separator
                            });
                            formatting.format(data, 1);
                            chart.draw(data, options);
                        });

                    } else if (payload.chart_type === 'Line') {
                        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                        google.charts.setOnLoadCallback(function () {
                            let data = google.visualization.arrayToDataTable(res.data);
                            let options = res.options;
                            let chart = new google.visualization.LineChart($chart_container);
                            let formatting = new google.visualization.NumberFormat({
                                decimalSymbol: decimal_separator,
                                groupingSymbol: thousands_separator
                            });
                            formatting.format(data, 1);
                            chart.draw(data, options);
                        });
                    } else if (payload.chart_type === 'Pie') {

                        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                        google.charts.setOnLoadCallback(function () {
                            let data = google.visualization.arrayToDataTable(res.data);
                            let options = res.options;
                            let chart = new google.visualization.PieChart($chart_container);
                            let formatting = new google.visualization.NumberFormat({
                                decimalSymbol: decimal_separator,
                                groupingSymbol: thousands_separator
                            });
                            formatting.format(data, 1);
                            chart.draw(data, options);
                        });

                    } else if (payload.chart_type === 'Donut') {

                        google.charts.load("current", {packages: ["corechart"], 'language': lang});
                        google.charts.setOnLoadCallback(function () {
                            let data = google.visualization.arrayToDataTable(res.data);
                            let options = Object.assign({}, res.options, {pieHole: 0.4});
                            let chart = new google.visualization.PieChart($chart_container);
                            let formatting = new google.visualization.NumberFormat({
                                decimalSymbol: decimal_separator,
                                groupingSymbol: thousands_separator
                            });
                            formatting.format(data, 1);
                            chart.draw(data, options);
                        });

                    } else if (payload.chart_type === 'Area') {

                        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                        google.charts.setOnLoadCallback(function () {
                            let data = google.visualization.arrayToDataTable(res.data);
                            let options = res.options;
                            let chart = new google.visualization.AreaChart($chart_container);
                            let formatting = new google.visualization.NumberFormat({
                                decimalSymbol: decimal_separator,
                                groupingSymbol: thousands_separator
                            });
                            formatting.format(data, 1);
                            chart.draw(data, options);
                        });

                    } else if (payload.chart_type === 'Scatter') {

                        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                        google.charts.setOnLoadCallback(function () {
                            let data = google.visualization.arrayToDataTable(res.data);
                            let options = res.options;
                            let chart = new google.visualization.ScatterChart($chart_container);
                            let formatting = new google.visualization.NumberFormat({
                                decimalSymbol: decimal_separator,
                                groupingSymbol: thousands_separator
                            });
                            formatting.format(data, 1);
                            chart.draw(data, options);
                        });

                    } else if (payload.chart_type === 'Stacked Bar') {

                        google.charts.load('current', {packages: ['corechart', 'bar'], 'language': lang});
                        google.charts.setOnLoadCallback(function () {
                            let data = google.visualization.arrayToDataTable(res.data);
                            let options = Object.assign({}, res.options, {
                                legend: {position: 'top', maxLines: 3},
                                bar: {groupWidth: '75%'},
                                isStacked: true,
                            });
                            let chart = new google.visualization.ColumnChart($chart_container);
                            let formatting = new google.visualization.NumberFormat({
                                decimalSymbol: decimal_separator,
                                groupingSymbol: thousands_separator
                            });
                            formatting.format(data, 1);
                            chart.draw(data, options);
                        });
                    } else if (payload.chart_type === 'Table' || payload.chart_type === 'SubTable') {
                        $($chart_container).html(res);
                    }
                }
            });
        });

        drawDashboardCharts();

        function drawDashboardCharts() {
            $($charts).each(function (i, $chart) {
                let payload = JSON.parse($($chart).attr('data-chart'));

                $.ajax({
                    type: "GET",
                    url: `/chart/${payload.id}`,
                    data : {
                        render: 'chart'
                    },
                    success: function (res) {
                        let $chart_container = $('#chart-' + payload.id)[0];

                        if (payload.chart_type === 'Bar') {

                            google.charts.load('current', {packages: ['corechart', 'bar'], 'language': lang});
                            google.charts.setOnLoadCallback(function () {
                                let data = google.visualization.arrayToDataTable(res.data);
                                let options = res.options;
                                let chart = new google.visualization.ColumnChart($chart_container);
                                let formatting = new google.visualization.NumberFormat({
                                    decimalSymbol: decimal_separator,
                                    groupingSymbol: thousands_separator
                                });
                                formatting.format(data, 1);
                                chart.draw(data, options);
                            });

                        } else if (payload.chart_type === 'Line') {
                            google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                            google.charts.setOnLoadCallback(function () {
                                let data = google.visualization.arrayToDataTable(res.data);
                                let options = res.options;
                                let chart = new google.visualization.LineChart($chart_container);
                                let formatting = new google.visualization.NumberFormat({
                                    decimalSymbol: decimal_separator,
                                    groupingSymbol: thousands_separator
                                });
                                formatting.format(data, 1);
                                chart.draw(data, options);
                            });
                        } else if (payload.chart_type === 'Pie') {

                            google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                            google.charts.setOnLoadCallback(function () {
                                let data = google.visualization.arrayToDataTable(res.data);
                                let options = res.options;
                                let chart = new google.visualization.PieChart($chart_container);
                                let formatting = new google.visualization.NumberFormat({
                                    decimalSymbol: decimal_separator,
                                    groupingSymbol: thousands_separator
                                });
                                formatting.format(data, 1);
                                chart.draw(data, options);
                            });

                        } else if (payload.chart_type === 'Donut') {

                            google.charts.load("current", {packages: ["corechart"], 'language': lang});
                            google.charts.setOnLoadCallback(function () {
                                let data = google.visualization.arrayToDataTable(res.data);
                                let options = Object.assign({}, res.options, {pieHole: 0.4});
                                let chart = new google.visualization.PieChart($chart_container);
                                let formatting = new google.visualization.NumberFormat({
                                    decimalSymbol: decimal_separator,
                                    groupingSymbol: thousands_separator
                                });
                                formatting.format(data, 1);
                                chart.draw(data, options);
                            });

                        } else if (payload.chart_type === 'Area') {

                            google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                            google.charts.setOnLoadCallback(function () {
                                let data = google.visualization.arrayToDataTable(res.data);
                                let options = res.options;
                                let chart = new google.visualization.AreaChart($chart_container);
                                let formatting = new google.visualization.NumberFormat({
                                    decimalSymbol: decimal_separator,
                                    groupingSymbol: thousands_separator
                                });
                                formatting.format(data, 1);
                                chart.draw(data, options);
                            });

                        } else if (payload.chart_type === 'Scatter') {

                            google.charts.load('current', {'packages': ['corechart'], 'language': lang});
                            google.charts.setOnLoadCallback(function () {
                                let data = google.visualization.arrayToDataTable(res.data);
                                let options = res.options;
                                let chart = new google.visualization.ScatterChart($chart_container);
                                let formatting = new google.visualization.NumberFormat({
                                    decimalSymbol: decimal_separator,
                                    groupingSymbol: thousands_separator
                                });
                                formatting.format(data, 1);
                                chart.draw(data, options);
                            });

                        } else if (payload.chart_type === 'Stacked Bar') {

                            google.charts.load('current', {packages: ['corechart', 'bar'], 'language': lang});
                            google.charts.setOnLoadCallback(function () {
                                let data = google.visualization.arrayToDataTable(res.data);
                                let options = Object.assign({}, res.options, {
                                    legend: {position: 'top', maxLines: 3},
                                    bar: {groupWidth: '75%'},
                                    isStacked: true,
                                });
                                let chart = new google.visualization.ColumnChart($chart_container);
                                let formatting = new google.visualization.NumberFormat({
                                    decimalSymbol: decimal_separator,
                                    groupingSymbol: thousands_separator
                                });
                                formatting.format(data, 1);
                                chart.draw(data, options);
                            });
                        } else if (payload.chart_type === 'Table' || payload.chart_type === 'SubTable') {
                            $($chart_container).html(res);

                            // Bind scroll event directly to .grid-stack-item-content
                            $('.chart-table-responsive').on('scroll', function() {
                                checkScroll($(this));
                            });
                        }
                    }
                });
            });
        }

        function updateChartLayoutParams() {
            let payload = [];

            let nodes = $('.grid-stack').data('gridstack').grid.nodes;
            $(nodes).each(function (i, item) {
                payload.push({
                    gs_x: item.x,
                    gs_y: item.y,
                    gs_width: item.width,
                    gs_height: item.height,
                    id: $(item.el).attr('data-chart-id')
                })
            });

            $.ajax({
                type: 'POST',
                url: '/dashboard/layout',
                data: {
                    charts: payload
                },
                success: function (res) {
                    console.log(res);
                }
            });
        }
    }
});